import { j as jsxRuntimeExports } from './../../../../../ext/react/jsx-runtime.js';
import { Base } from '../../../Internal/Base/Base.js';

const pathStrings = {
    24: [
        'M4.993 5.16v9.042c0 1.48.81 2.372 2.149 2.372a3.96 3.96 0 001.317-.243v.142c-.77 1.196-1.865 1.865-3.243 1.865C3.41 18.338 2 17.162 2 15.013V9.377H.35v-.223l4.4-3.994h.243zm12.133 2.859l3.061 6.994-1.48 3.264h-.202L13.963 8.019h3.163zm-5.677 0l3.062 6.994-1.48 3.264h-.203l-3.953-8.9H6V8.019h5.45zm11.901 0l-1.987 3.912h-.142c0-.973-.446-2.919-.953-3.912h3.082z',
    ],
};
const IconTreatwellLogo = ({ size, className, ...rest }) => {
    const paths = pathStrings[size].map((d, i) => (jsxRuntimeExports.jsx("path", { d: d, fillRule: "evenodd" }, String(i))));
    return (jsxRuntimeExports.jsx(Base, { as: "svg", height: size, width: size, viewBox: `0 0 ${size} ${size}`, className: className, xmlns: "http://www.w3.org/2000/svg", "aria-hidden": "true", preserveAspectRatio: "xMidYMid meet", fill: "currentColor", ...rest, children: paths }));
};
IconTreatwellLogo.displayName = 'IconTreatwellLogo';

export { IconTreatwellLogo };
//# sourceMappingURL=IconTreatwellLogo.js.map
